import * as React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'
import { noop } from '@avcan/utils/function'
import * as Root from '../contexts/root'
import * as Buttons from 'components/button'
import * as Alerts from 'components/alert'
import { ButtonSet, Next } from './Navigation'
import { Renderer } from '../schema/components'
import styles from './Form.module.css'

export default function Form() {
    const schema = Root.useFormSchema()
    const [state, send] = Root.useService()
    const { ownsObservations } = state.context
    const { handleSubmit } = useFormContext()
    const onSubmit = React.useMemo(() => {
        return handleSubmit(values => {
            send({
                type: 'SUBMIT',
                payload: { values },
            })
        })
    }, [handleSubmit, send])

    return (
        <form className={styles.Form} noValidate onSubmit={onSubmit}>
            <Renderer {...schema} />
            <ButtonSet>
                <Next as={Buttons.Submit} onClick={noop}>
                    {ownsObservations ? (
                        <FormattedMessage
                            description="Mountain Information Network Form"
                            defaultMessage="Preview my report"
                        />
                    ) : (
                        <FormattedMessage
                            description="Mountain Information Network Form"
                            defaultMessage="Preview report"
                        />
                    )}
                </Next>
            </ButtonSet>
            <ResetButton />
        </form>
    )
}

// Utils components
function ResetButton() {
    const [state, send] = Root.useService()
    const { ownsObservations } = state.context
    const onReset = React.useCallback(() => {
        const notification = <UndoNotification />

        send({
            type: 'RESET',
            payload: { notification },
        })
    }, [send])

    return (
        <Buttons.Button
            hidden={!state.matches('form.dirty')}
            onClick={onReset}
            large
            className={styles.ResetButton}>
            {ownsObservations ? (
                <FormattedMessage
                    description="Mountain Information Network Form"
                    defaultMessage="Reset my report to its initial values"
                />
            ) : (
                <FormattedMessage
                    description="Mountain Information Network Form"
                    defaultMessage="Reset report to its initial values"
                />
            )}
        </Buttons.Button>
    )
}
function UndoNotification() {
    const [state, send] = Root.useService()
    const { ownsObservations } = state.context
    const undo = React.useCallback(() => {
        send('UNDO')
    }, [send])

    return (
        <Alerts.Info>
            <Alerts.FlexContent>
                {ownsObservations ? (
                    <FormattedMessage
                        description="Mountain Information Network Form"
                        defaultMessage="Your report has been reset to their initial values."
                    />
                ) : (
                    <FormattedMessage
                        description="Mountain Information Network Form"
                        defaultMessage="Report has been reset to their initial values."
                    />
                )}
                <Buttons.Button onClick={undo}>
                    <FormattedMessage
                        description="Mountain Information Network Form"
                        defaultMessage="Undo"
                    />
                </Buttons.Button>
            </Alerts.FlexContent>
        </Alerts.Info>
    )
}
